import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Margin } from 'components/ui/Margin/Margin'
import { Flex, InputOtp, Text } from 'components/uiKit'

import { UserModuleKeys } from '../../../modules/UserModule/types'

type CodeInputProps = {
  onChange: ((value: string) => void) | undefined
  length: number
  value: string
  disabled?: boolean
}

export const CodeInput = ({ onChange, length, value, disabled }: CodeInputProps) => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${UserModuleKeys.codeInput}.${key}`

  useEffect(() => {
    const elements = document.querySelectorAll('input')
    elements?.forEach((elem) => elem.setAttribute('inputmode', 'tel'))
  }, [])
  return (
    <Flex vertical>
      <Text>{t(getKey('Код подтверждения'))}</Text>
      <Margin mt={20}>
        <InputOtp id={'inputOTP'} onChange={onChange} length={length} value={value} autoFocus disabled={disabled} />
      </Margin>
    </Flex>
  )
}
